<template>
  <el-dialog title="申请视频面试" :visible.sync="is_show" width="4rem">
    <div class="apply-video">
      <el-row>
        <el-col :span="4">
          <el-image
            style="width: 0.3rem; height: 0.3rem"
            :src="dataParams.company_logo || dataParams.logo_url"
            fit="cover"
            :lazy="true"
          ></el-image>
        </el-col>
        <el-col :span="20">
          <span>{{ dataParams.company_name }}</span>
        </el-col>
      </el-row>
      <div class="apply-form">
        <p class="apply-desc-title">请选择申请视频面试的职位：</p>
        <el-select v-model="job_value" placeholder="请选择">
          <el-option
            v-for="(item, index) in dataParams.jobs"
            :key="index"
            :label="item.job_name"
            :value="index"
          ></el-option>
        </el-select>
      </div>
      <div class="apply-desc">
        <p class="apply-desc-title">申请须知:</p>
        <p class="apply-desc-text">
          确定申请后，简历将默认发送给企业方，且企业同意申请后才在可进行视频面试。可在页面右侧浮标视频面试间查看申请状态。
        </p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitQueue" v-loading="loading"
        >确定申请</el-button
      >
      <el-button @click="dialogChangeFn">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Vue from "vue";
import { Select, Option } from "element-ui";
Vue.use(Select);
Vue.use(Option);

export default {
  name: "apply-video",
  props: {
    params: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    },
    video_jobfair_id: {
      type: String,
      default: "",
    },
  },
  computed: {
    dataParams() {
      const { params, defaultParams } = this;

      let data = Object.assign({}, defaultParams, params);

      return data;
    },
  },
  mounted() {
    this.job_value = this.index;
  },
  data() {
    return {
      defaultParams: {},
      is_show: false,
      job_value: 0,
      loading: false,
    };
  },
  methods: {
    dialogChangeFn: function () {
      this.is_show = !this.is_show;
    },
    // 申请排队\ 同一个求职者，同一个公司只能排一个面试
    submitQueue: function () {
      var _self = this;

      // 确定
      const { dataParams, video_jobfair_id, job_value } = this;

      const { company_name, video_erp_register_id, company_id, jobs } =
        dataParams || {};

      const job = jobs[job_value];

      let params = {
        publish_id: job.publish_id,
        job_name: job.job_name,
        company_name,
        video_erp_register_id,
        company_id,
        video_jobfair_id,
      };

      if (_self.loading) {
        return;
      }

      _self.loading = true;

      _self.$util
        .post("kzp_video_jobfair", "apply", params)
        .then((res) => {
          _self.loading = false;

          if (res.code !== 1) {
            var err_msg = res.msg || "操作失败!";
            _self.$message.error(err_msg);
            return;
          }

          _self.dialogChangeFn();

          _self.$message.success("排队成功!");

          params.invitation_apply_id = res.data;

          // 通知父级页面
          _self.$emit("apply", params);
        })
        .catch(() => {
          // 处理不提示的错误!
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-video {
}
</style>


// WEBPACK FOOTER //
// src/components/video/ApplyVideo.vue